<template>
  <div class="toolbar">
    <div class="grid">
      <div class="toggleSidebar__btn">
        <Button
          icon="pi pi-bars"
          class="p-button-rounded p-button-text p-button-lg"
          @click="visibleLeft = !visibleLeft"
          style="color: #000000"
          test-id="toggleSidebar"
        />
      </div>

      <div class="general-container">
        <div class="top-menu">
          <div class="side-options" @click="redirectToHome">
            <img src="../../assets/logoSIIS.png" alt="Logo SIIS" style="height: 3em" />
            <p style="font-weight: 700; margin: 0" class="primaryFont">
              Sistema Integral Informático de Seguridad
            </p>
          </div>
          <div class="top-menu-alert primaryFont" v-if="user.userdata.usuarioNombre">
            <div
              class="notification-icon mr-2"
              :style="{ color: notificationStore.pendingCount === 0 ? '#bfbfbf' : '#D32F2F' }"
              @click="toggleNotificationsOptionsMenu"
              v-if="isNotificanteDepartamental"
            >
              <i class="pi pi-bell" />
              <span
                class="notification-badge"
                :class="{ neutral: notificationStore.pendingCount === 0 }"
              >
                {{ notificationStore.pendingCount }}
              </span>
            </div>
            <div>
              <div class="pipe one" />
            </div>
            <div class="dependencyOptions-descriptions description">
              <h1 class="username description" v-if="showDependencia">
                {{ user?.userdata?.dependenciaNombre || user?.userdata?.juzgadoNombre }}
              </h1>
              <p class="userrole description">
                {{ user.userdata ? user.userdata.tipoUsuario : "SuperUser" }}
              </p>
            </div>
            <div>
              <div class="pipe two" />
            </div>
            <div class="profileOptions">
              <div class="profileIcon" v-if="user.userdata.usuarioNombre">
                <CircleUserRound style="width: 2.5em; height: 2.5em" />
              </div>
              <div
                class="profileOptions-descriptions description"
                v-if="user.userdata.usuarioNombre"
              >
                <p class="username description">
                  {{ user.userdata.nombre }} {{ user.userdata.apellido }}
                </p>
                <p class="userrole description top_username">{{ user.userdata.usuarioNombre }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <Sidebar
        :isVisible.sync="visibleLeft"
        @logout="logout"
        @cleanStore="cleanStore"
        :userType="tipoUsuario"
      ></Sidebar>
    </div>
  </div>
</template>

<script setup>
import Sidebar from "./Sidebar.vue";
import { getPageName } from "../../utils/getPageName";
import { useNotificationStore } from "@/store/Pinia/useNotificationStore";
import { useRest } from "@/composables/useRest";
import { ref, computed, onMounted } from "vue";
import { useStoreCompat } from "@/composables/useStoreCompat";
import { useToast } from "@/composables/useToast";
import { useRouterCompat } from "@/composables/useRouterCompat";
import { CircleUserRound } from "lucide-vue";

const store = useStoreCompat();
const toast = useToast();
const rest = useRest();
const { router } = useRouterCompat();
const notificationStore = useNotificationStore();

const visibleLeft = ref(false);
const menuNotificationsOptions = ref(null);

const user = computed(() => store.state.user);
const tipoUsuario = computed(() => user.value.userdata.tipoUsuario);
const formType = computed(() => store.state.sumarioViews?.actuacion);
const actuacionType = computed(() => {
  const type = store.state.sumario.formType;
  return type ? type.toUpperCase() : null;
});
const currentTitle = computed(() => getPageName(router, actuacionType.value));
const showDependencia = computed(
  () => tipoUsuario.value !== "Notificante" && tipoUsuario.value !== "Notificante - Departamental"
);
const isNotificanteDepartamental = computed(
  () => tipoUsuario.value === "Notificante - Departamental"
);

const cargarPendientes = async () => {
  const departamental =
    user.value?.userdata.DepartamentalID ?? user.value?.userdata.departamentalID;
  await notificationStore.getPendientes(departamental);
};

const redirectToHome = () => {
  router.push("/");
};

const toggleNotificationsOptionsMenu = (event) => {
  console.log("notificationStore", notificationStore);
};

const goToRoute = (routePath) => {
  visibleLeft.value = false;
  router.push(routePath);
  store.dispatch("sumario/resetState");
};

const logout = async () => {
  store.dispatch("sumarioList/resetActuaciones");
  await store.dispatch("user/logout");
  router.push("/");
  location.reload();
};

const cleanStore = () => {
  store.dispatch("sumario/resetState");
};

onMounted(() => {
  if (tipoUsuario.value === "Notificante - Departamental") {
    cargarPendientes();
  }
});
</script>

<style scoped>
div #overlayNotificationsOptions {
  min-width: 250px;
  margin-left: -10vw;
}
.grid {
  flex-wrap: nowrap;
}
.general-container {
  width: 100%;
}

>>> .p-sidebar-header {
  display: none;
}
>>> .p-sidebar-content {
  margin: 0;
  padding: 0;
  background-color: #252729;
  overflow: hidden;
}

div.active > .submenu {
  display: inherit;
  padding: 15px 15px;
}

div.submenu > .submenu {
  display: inherit;
}
.division {
  padding: 0;
  margin: 0;
}
.submenu {
  display: none;
  padding-left: 10px;
}
.submenu > div {
  cursor: pointer;
  padding: 10px 0;
  color: rgb(255, 255, 255);
}
.submenu > div.active {
  color: #dc3545;
}
.subMenuTitle {
  margin: 0;
  color: #686767;
  font-weight: 1000px;
}
.toolbar > div {
  align-items: center;
}
.tabmenu {
  padding-bottom: 12px;
}
.right {
  margin-left: auto;
}
.noWidth {
  width: 0;
}
.nameUser {
  color: rgb(255, 255, 255);
  float: right;
}
.top-menu {
  display: flex;
  justify-content: space-between;
  height: 3.5em;
  align-items: center;
}
.top-menu-alert {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 48px;
  color: #9f9f9f;
}
.profileOptions {
  display: flex;
  align-items: center;
}
.dependencyOptions-descriptions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 0;
}
.top-menu-alert-section {
  flex-wrap: nowrap;
  padding-top: 3px;
  padding-left: 17px;
}

.notif__Menu {
  margin-top: 2px;
  margin-right: 10px;
}
.side-options {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  margin-left: 30px;
}
.side-page-name {
  margin-top: 2px;
  margin-left: 15px;
  margin-bottom: 0;
}
.bell-button {
  position: relative;
}

>>> .pi-bell:before {
  font-size: 22px;
}

.p-button.p-button-secondary:enabled:focus,
.p-buttonset.p-button-secondary > .p-button:enabled:focus,
.p-splitbutton.p-button-secondary > .p-button:enabled:focus {
  box-shadow: 0 0 0 0.2rem #30b2e198;
}
.pipe {
  margin: 0 5px 0 5px;
  border: #6d70723b 1px solid;
  padding: 0;
  height: 34px;
}
.path_class {
  margin-left: 10px;
  list-style: none;
  font-weight: 700;
  word-spacing: 0.4rem;
}
.new_form {
  margin: 0;
  padding: 5px;
  list-style: none;
  background-color: inherit;
  border-radius: 7px;
}
.path_nuevo > span:hover {
  animation: underline 4s linear alternate infinite;
}
.new_form:hover {
  background-color: #2e2d2d;
}
@keyframes underline {
  0% {
    text-decoration: #b9b8b8 2px underline;
    color: #a4a5a7;
  }
  25% {
    text-decoration: #707070 2px underline;
    color: #d3d3d3;
  }
  50% {
    text-decoration: #a0a0a0 2px underline;
    color: #bdbdbd;
  }
  75% {
    text-decoration: #cfcfcf 2px underline;
    color: #d8d8d8;
  }
  100% {
    text-decoration: #f1f1f1 2px underline;
    color: #fcfcfc;
  }
}
.path_nuevo {
  list-style: none;
  background-color: inherit;
  margin: 10px 0;
  font-weight: 700;
  color: rgb(196, 196, 196);
}
.alerts-number {
  position: relative;
  top: -20px;
  right: 15px;
  font-size: 11px;
  color: #fff;
  background-color: #2196f3;
  border-radius: 7px;
  padding: 2px 5px;
}
.description {
  font-size: 12px;
  font-weight: bold;
  color: #9f9f9f !important;
  margin: 1px 3px;
}
/* @media screen and (max-width: 1200px) { */
@media screen and (max-width: 651px) {
  .description {
    display: none;
  }
  .side-page-name {
    display: none;
  }
  .pipe.one {
    display: none;
  }
}
.username {
  color: #323232;
  font-size: 11px;
}
.userrole {
  color: #686868;
  font-size: 10px;
}
>>> .p-menu .p-menuitem-link {
  margin: 0 15px;
  border-radius: 4px;
}
.searchTopBar {
  cursor: pointer;
}
.invisibleDiv {
  position: absolute;
  z-index: 2;
  height: 30px;
  width: 30px;
  margin-left: 187px;
  cursor: pointer;
}
.notification-icon {
  position: relative;
  font-size: 24px;
  color: #d32f2f;
  cursor: pointer;
}

.notification-badge {
  position: absolute;
  top: -8px;
  right: -6px;
  background-color: #d32f2f;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: bold;
  line-height: 1;
}

.notification-badge.neutral {
  background-color: #bfbfbf;
  color: #ffffff;
}
</style>
@/router/RoutesConfig/actuacionesConfig/actuacionesConfig@/router/RoutesConfig/depositoConfig
